import { css } from 'styled-components';

import { theme } from '../../../../common/ui/theme';

export const stickyProductColumnStyles = css<{ $showScrollShadow: boolean }>`
    position: sticky;
    left: 0;
    border-right: 1px solid ${theme.colors.background.inset};

    &::after {
        content: '';
        position: absolute;
        inset-block: 0;
        right: -${theme.space[8]};
        width: ${theme.space[8]};
        box-shadow: inset 8px 0 8px -8px rgba(25, 54, 67, 0.15);
        opacity: ${({ $showScrollShadow }) => ($showScrollShadow ? 1 : 0)};
        transition: opacity 75ms ease-in-out;
        pointer-events: none;
        z-index: 1;
    }
`;
